import Quill from 'quill';

const Parent = Quill.import('formats/image');

const ATTRIBUTES = [
  'alt',
  'height',
  'width',
  'data-shortcode',
];

export class Image extends Parent {
  static tagName = 'IMG';

  static formats(domNode) {
    return ATTRIBUTES.reduce((formats, attribute) => {
      if (domNode.hasAttribute(attribute)) {
        formats[attribute] = domNode.getAttribute(attribute);
      }
      return formats;
    }, {});
  }

  format(name, value) {
    if (ATTRIBUTES.indexOf(name) > -1) {
      if (value) {
        this.domNode.setAttribute(name, value);
      } else {
        this.domNode.removeAttribute(name);
      }
    } else {
      super.format(name, value);
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/content/shared/components/inputs/body/quill/formats/image/image.format.ts